module.exports = __webpack_public_path__ + "static/forecast/weather/dayheavyrain-110cfeb8de4d9048a55c12ee3f960d1f.svg";